import * as React from "react";
import { cn } from "../shared/ui/index.ts";
import { I } from "../shared/icons/icons.tsx";

export function StatsWidget() {
  const stats = [
    {
      label: "Patients vus",
      value: 14,
      delta: "+12%",
      up: true,
      hint: "aujourd'hui",
    },
    {
      label: "Temps moyen",
      value: "22min",
      delta: "-3min",
      up: true,
      hint: "consultation",
    },
    {
      label: "En attente",
      value: 3,
      delta: null,
      up: null,
      hint: "salle d'attente",
    },
    {
      label: "Téléconsultations",
      value: 5,
      delta: "+2",
      up: true,
      hint: "cette semaine",
    },
  ];
  return (
    <div className="grid grid-cols-2 gap-2">
      {stats.map((s, i) => (
        <div
          key={i}
          className="rounded-md border border-sf-border bg-sf-surface-alt p-3"
        >
          <div className="text-[11px] font-semibold uppercase tracking-wide text-sf-text-muted">
            {s.label}
          </div>
          <div className="mt-1.5 flex items-baseline gap-2">
            <div className="text-[22px] font-bold tracking-tight text-sf-text">
              {s.value}
            </div>
            {s.delta && (
              <div
                className={cn(
                  "inline-flex items-center gap-0.5 text-[11px] font-semibold",
                  s.up ? "text-sf-success" : "text-sf-danger",
                )}
              >
                {s.up ? <I.TrendUp size={11} /> : <I.TrendDown size={11} />}
                {s.delta}
              </div>
            )}
          </div>
          <div className="mt-0.5 text-[11px] text-sf-text-muted">{s.hint}</div>
        </div>
      ))}
    </div>
  );
}

// --- Messages patients ---
